/* esm.sh - unhead@3.1.0/dist/shared/unhead.CH30252c */
export * from "/*unhead@3.1.0/esnext/dist/shared/unhead.CH30252c.mjs";
